import { TWhatsappContent } from './whatsapp'

export type DirectionType = 'egress' | 'ingress'
export enum MessageType {
  SMS = 'sms',
  WhatsApp = 'whatsapp',
}

export type BaseLog = {
  campId: number
  campaignName?: string
  carrierID: number
  charged: number
  contactId: number
  countryCode: string
  countryName: string
  created: string
  deliveredToPhone: string
  direction: DirectionType
  done: boolean
  engagementFlowId: number
  error: string
  firstName: string
  fullPhoneNumber: string
  id: string
  lastName: string
  message: string
  new: boolean
  partId: string
  read: boolean
  recipient: string
  runId: number
  sender: string
  successT: string
}

export type SMSLog = BaseLog & {
  deliveredToTelco: boolean
  engagementId: number
  engagementPartId: string
  engagementRunId: number
  pricePerPart: number
  successPartCount: number
  type: MessageType.SMS
}

export type WhatsAppLog = BaseLog & {
  audioFiles: string[] | null
  content?: TWhatsappContent
  documentFiles: string[] | null
  imageFiles: string[] | null
  videoFiles: string[] | null
  location?: {
    latitude?: string
    longitude?: string
    address?: string
    label?: string
  }
  type: MessageType.WhatsApp
}
